import limitTypes from '@transfeeradev/api-enums/limitType';

export const limitsTypeDescriptions = {
  [limitTypes.TRANSACTION]: {
    title: 'Limite por transação',
    tooltipDescription: 'Valor máximo permitido por transação individual, independentemente do horário ou dia.'
  },
  [limitTypes.DAILY]: {
    title: 'Limite diurno',
    tooltipDescription: 'Valor máximo para transações feitas entre 06h e 20h, de segunda a sexta, incluindo feriados.'
  },
  [limitTypes.NIGHTLY]: {
    title: 'Limite noturno',
    tooltipDescription:
      'Valor máximo para transações entre 20h e 06h, em qualquer dia (inclui fins de semana e feriados)'
  },
  [limitTypes.WEEKEND]: {
    title: 'Limite fim de semana',
    tooltipDescription: 'Valor máximo para transações feitas aos sábados e domingos, entre 06h e 20h.'
  }
};
